import store from '@/core/store';
import { computed, Ref } from '@vue/composition-api';
import { get, set } from 'lodash-es';

function generateVuexPropertieHook<N extends string> (name: N): <T>() => { [x in N]: Ref<T> };
function generateVuexPropertieHook<N extends string, A extends string> (name: N, alias?: A): <T>() => { [x in A]: Ref<T>};
function generateVuexPropertieHook<N extends string, A extends string> (name: N, alias?: A) {
  let cache: Ref<unknown>;
  return <T>() => {
    if (!cache) {
      cache = computed({
        get: () => get(store, `state.webPanel[${name}]`),
        set: val => store.commit('webPanel/set', state => { set(state, name, val); }),
      }) as Ref<T>;
    }
    const key = alias || name;
    return {
      [key]: cache,
    } as { [x in typeof key]: typeof cache};
  };
}

const useLoading = generateVuexPropertieHook('loading');
const useTitle = generateVuexPropertieHook('title');
const useFocusMode = generateVuexPropertieHook('focusMode');
const useShowHeader = generateVuexPropertieHook('showHeader');
const useIsNavigationEnabled = generateVuexPropertieHook('navMenu.enabled', 'isNavigationEnabled');
const useIsNavigationOpen = generateVuexPropertieHook('navMenu.open', 'isNavigationOpen');

export function useWebPanel () {
  return {
    ...useTitle<string>(),
    ...useFocusMode<boolean>(),
    ...useLoading<boolean>(),
    ...useShowHeader<boolean>(),
    ...useIsNavigationEnabled<boolean>(),
    ...useIsNavigationOpen<boolean>(),
  };
};
